import { CALCWEIGHT } from '@/models/GenerateCondit/Interrelated';
import { columnSearch, sorteColum } from '@/utils/columnSearch';
// import { BaseQuery2 } from '@/utils';
/**
 * @startDate
 * @endDate
 * @originProvinceArea  营运区
 * @productType 产品类型
 */
export const TableQuery = params => {
  const andFilters = [{ key: 'scanType', value: '录单' }];
  let inFilters = [];
  if (params.originProvinceArea && params.originProvinceArea.length > 0) {
    inFilters = [{ key: 'originProvinceArea', value: params.originProvinceArea }];
  }
  return [
    {
      // 获取所有省区
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['originProvinceArea'],
      startDate: params.startDate,
      endDate: params.endDate,
      // aggregators: BaseQuery2(),
      andFilters: andFilters,
      inFilters: [].concat(inFilters),
    },
    {
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['originProvinceArea'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: andFilters,
      inFilters: [{ key: 'productType', value: params.productType }].concat(inFilters),
    },
  ];
};

export const getColumnList = (clolumnCofList, weekindexArr) => {
  const columnObjList = clolumnCofList.map((item, index) => {
    const idx = weekindexArr[index];
    return {
      title: item.title,
      dataIndex: `calcWeight${idx}`,
      align: 'center',
      // ellipsis: true,
      // width: 100,
      sorter: sorteColum(`calcWeight${idx}`, true),
    };
  });
  columnObjList.unshift({
    title: '营运区',
    dataIndex: 'originProvinceArea',
    align: 'center',
    // ellipsis: true,
    fixed: 'left',
    width: 200,
    ...columnSearch('originProvinceArea'),
  });
  // console.log(columnObjList)
  return columnObjList;
};
